<template>
  <div style="padding-bottom: 5em">
    <sui-segment id="footer" vertical aligned="center">
      &copy;&nbsp;
      <span>{{ $t('strCopyright') }}</span><br />
      <span>{{ $t('stringHotline') }}</span> &nbsp;|&nbsp;
      <a class="footerItem" @click="openModal('modalHelp')">{{ $t('labelHelp') }}</a> &nbsp;|&nbsp;
      <a class="footerItem" @click="openModal('modalContact')">{{ $t('labelContact') }}</a> &nbsp;|&nbsp;
      <a class="footerItem" @click="openModal('modalImprint')">{{ $t('labelImprint') }}</a> &nbsp;|&nbsp;
      <a class="footerItem" @click="openModal('modalPrivacy')">{{ $t('labelPrivacy') }}</a> &nbsp;|&nbsp;
      <sui-dropdown simple :options="language" text="Language" v-model="$i18n.locale" />
    </sui-segment>
    <ModalHelp :open="modalHelp" v-on:closeModal="closeModal"></ModalHelp>
    <ModalImprint :open="modalImprint" v-on:closeModal="closeModal"></ModalImprint>
    <ModalContact :open="modalContact" v-on:closeModal="closeModal"></ModalContact>
    <ModalPrivacy :open="modalPrivacy" v-on:closeModal="closeModal"></ModalPrivacy>
  </div>
</template>
<script>
  import ModalHelp from '@/views/modal/Help.vue';
  import ModalImprint from '@/views/modal/Imprint.vue';
  import ModalContact from '@/views/modal/Contact.vue';
  import ModalPrivacy from '@/views/modal/Privacy.vue';

  export default {
    name: 'Footer',
    components: {
      ModalHelp,
      ModalImprint,
      ModalContact,
      ModalPrivacy
    },
    data() {
      return {
        modalHelp: false,
        modalImprint: false,
        modalContact: false,
        modalPrivacy: false,
        currentLanguage: 'de',
        language: [
          { key: 'gb', value: 'gb', flag: 'gb', text: 'English' },
          { key: 'de', value: 'de', flag: 'de', text: 'German' }
        ]
      }
    },
    methods: {
      openModal(modalName) {
        this.modalHelp = (modalName == 'modalHelp') ? true : false
        this.modalImprint = (modalName == 'modalImprint') ? true : false
        this.modalContact = (modalName == 'modalContact') ? true : false
        this.modalPrivacy = (modalName == 'modalPrivacy') ? true : false
      },
      closeModal() {
        this.modalHelp = false
        this.modalImprint = false
        this.modalContact = false
        this.modalPrivacy = false
      }
    }
  }
</script>
<style lang="scss" scoped>
  #footer {
    color: white;
    margin-bottom: 5em;
  }

  .footerItem {
    color: white;
    cursor: pointer;
  }
</style>
